import { render, staticRenderFns } from "./YaoShiListDetail.vue?vue&type=template&id=0fd94db8&scoped=true"
import script from "./YaoShiListDetail.vue?vue&type=script&lang=js"
export * from "./YaoShiListDetail.vue?vue&type=script&lang=js"
import style0 from "./YaoShiListDetail.vue?vue&type=style&index=0&id=0fd94db8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd94db8",
  null
  
)

export default component.exports